import { useWindowDimensions } from 'react-native';
import { isMobile } from '../../../utilities';

const useMobileSizing = () => {
  const layout = useWindowDimensions();
  return isMobile || layout.width < 695;
};

export default useMobileSizing;
